import type { RefundRequestWizardStepIds } from './steps';
import type { FormValidationSchema } from './steps/catalog-form/schema';
import type { ExternalCourseFormSchema } from './steps/external-item-form/components/course/schema';
import type { ExternalItemFormSchema } from './steps/external-item-form/components/learning-aid/schema';
import type { WizardValuesBase } from '@/context/wizard/types';
import type { ResourceApproval } from '@/data/subsidy/interfaces';
import type {
  EligibleResourceType,
  Policy,
} from '@/data/subsidy/policies/interfaces';
import type { ResourceTypes } from '@/models/resources';

export enum RefundQueryParams {
  Invoice = 'comprovantes',
  Description = 'descricao',
}

export interface ExternalItemFormData {
  course: ExternalCourseFormSchema | null;
  learningAid: ExternalItemFormSchema | null;
}

export interface RefundRequestWizardProps extends WizardValuesBase {
  currentStepId: RefundRequestWizardStepIds;
  policies: Policy[];
  selectedPolicy: Policy;
  resourceApprovals: ResourceApproval[];
  [RefundRequestWizardStepIds.ResourceType]: 'new' | ResourceApproval;
  [RefundRequestWizardStepIds.SelectPolicy]: Policy;
  [RefundRequestWizardStepIds.ItemSource]: EligibleResourceType | 'external'; // na hora de enviar o formulário, precisa ser "external" em vez de "360"
  [RefundRequestWizardStepIds.ExternalResourceType]: ResourceTypes;
  [RefundRequestWizardStepIds.ExternalItemForm]: ExternalItemFormData;
  [RefundRequestWizardStepIds.CatalogForm]: FormValidationSchema;
}
